export const faq_data = [
  {
    key: "1",
    questions: "What is an HRMS?",
    answers: "Software system that automates and manages various human resources tasks",
    category: "General",
  },
  {
    key: "2",
    questions: "How does an HRMS benefit organizations?",
    answers: 'It enhances operational efficiency, reduces manual errors, and centralizes HR tasks',
    category: "General",
  },
  {
    key: "3",
    questions: "Is the data stored in an SmartHR secure?",
    answers: "Yes, SmartHR is design with advanced security measures, including data encryption",
    category: "Feature",
  },
  {
    key: "4",
    questions: "How do I add a new employee to the HRMS?",
    answers: "Add new employees by  entering their personal details & setting up their profiles.",
    category: "Employee",
  },
  {
    key: "5",
    questions: "How do I generate custom reports in the SmartHR?",
    answers: "Custom reports can be generated using the reporting module within the HRMS",
    category: "Reports",
  },
  {
    key: "6",
    questions: "How do I schedule training sessions in the HRMS?",
    answers: "Creating training events, setting dates and times, and enrolling employees",
    category: "Leaves",
  },
  {
    key: "7",
    questions: "How do I process payroll in the SmartHR?",
    answers: "Reviewing employee hours and deductions and executing payments.",
    category: "Payroll",
  },
  {
    key: "8",
    questions: "How do I export reports from the HRMS?",
    answers: "Export reports by selecting the desired report format and using the export function",
    category: "Reports",
  },
  {
    key: "9",
    questions: "Can I track employee attendance and absences?",
    answers: "Yes, track attendance and absences by using the attendance management",
    category: "Employee",
  },
  {
    key: "10",
    questions: "How can I assign a ticket to a specific team member?",
    answers: "Assign a ticket by selecting the ticket from the queue, choosing the team member",
    category: "Tickets",
  },
];
